import styled from 'styled-components';

export const Container = styled.footer`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-top: 2rem;

  > div {
    background: var(--black);
    border-radius: 1.2rem 1.2rem 0 0;
    padding: 2rem 0;

    &:not(.footer-background-new-letter) {
      background-color: var(--black);
    }
  }

  .footer-body {
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
  }

  .footer-body-info {
    display: flex;
    gap: 1.6rem;
  }

  .footer-body-info.space {
    justify-content: space-between;
  }

  .footer-body-info.column {
    flex-direction: column;
  }

  .footer-body-info.column > div {
    display: flex;
    gap: 2.6rem;
  }

  .footer-body-group {
    display: flex;
    gap: 2.6rem;
  }

  .footer-body-info {
    color: var(--white);

    .footer-title {
      color: var(--white);
      font-size: 0.8rem;
      text-transform: uppercase;
      font-weight: 800;
      margin-bottom: 0.6rem;
    }

    .footer-body-group li {
      display: flex;
      font-size: 0.7rem;
      font-weight: 500;
    }

    .footer-body-group li a {
      padding: 0.2rem 0;
    }

    .footer-body-group li a:hover {
      text-decoration: underline;
    }

    .footer-body-group-selos {
      display: flex;
      max-width: 30rem;
      align-items: center;
      flex-wrap: wrap;
      gap: 1rem;
    }

    .footer-body-social-media ul {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 0.4rem;
    }

    .footer-body-payment-methods ul {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 0.4rem;
    }
  }

  .footer-background-about {
    font-size: 0.5rem;
    margin-top: -2rem;
    color: var(--white);
  }

  .footer-background-body + .footer-background-about {
    border-radius: 0;
  }

  @media (max-width: 1200px) {
    > div {
      padding: 2rem;
    }
  }

  @media (max-width: 1150px) {
    .footer-body .footer-body-info {
      flex-direction: column;

      .footer-body-group-selos {
        max-width: 100%;
      }
    }
  }

  @media (max-width: 768px) {
    .footer-body-info.column > div {
      flex-direction: column;
    }

    .footer-body-group {
      gap: 1rem;
    }
  }

  @media (max-width: 580px) {
    .footer-body-group {
      flex-wrap: wrap;
    }
  }
`;
